import { Profile } from "@/types/profile";
import { Session, User } from "@supabase/supabase-js";
import { createContext } from "react";

export interface AuthContextType {
  session: Session | null;
  user: User | null;
  profile: Profile | null;
  signUp: (
    email: string,
    password: string,
    metadata?: Record<string, unknown>,
    captchaToken?: string
  ) => Promise<void>;
  signIn: (email: string, password: string, captchaToken?: string) => Promise<void>;
  signInWithGoogle: (options?: { scopes?: string; redirectTo?: string }) => Promise<void>;
  signOut: () => Promise<void>;
  resetPassword: (email: string) => Promise<void>;
  updateProfile: (profileData: Partial<Profile>) => Promise<boolean>;
  uploadAvatar: (file: File) => Promise<string | null>;
  loading: boolean;
  isAuthenticated: boolean;
  refreshProfile: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextType | undefined>(
  undefined
);
